import { RemoteGetAllCoursesFromEntity } from 'data/usecases';
import { makeApiUrlEntitiesCourses } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllCoursesFromEntity =
  (): RemoteGetAllCoursesFromEntity => {
    return new RemoteGetAllCoursesFromEntity(
      makeApiUrlEntitiesCourses(),
      makeAxiosHttpClient(),
    );
  };
